var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGithubIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3_206",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 21
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1939 2.03878C5.69022 2.03878 2.03877 5.69022 2.03877 10.1939C2.03877 14.0152 4.67015 17.2127 8.21762 18.0975C8.17956 17.9874 8.1551 17.8597 8.1551 17.7013V16.3075C7.82414 16.3075 7.26959 16.3075 7.13027 16.3075C6.57233 16.3075 6.07623 16.0676 5.83565 15.6218C5.56857 15.1264 5.52236 14.3686 4.86044 13.9051C4.66404 13.7509 4.81355 13.5748 5.03985 13.5986C5.4578 13.7169 5.80439 14.0037 6.13059 14.4291C6.45544 14.8552 6.60835 14.9517 7.21522 14.9517C7.50949 14.9517 7.94986 14.9347 8.36441 14.8695C8.58732 14.3034 8.97265 13.7821 9.4436 13.5361C6.72796 13.2568 5.43197 11.9058 5.43197 10.0716C5.43197 9.28187 5.76837 8.518 6.33991 7.87443C6.15234 7.23561 5.91652 5.93284 6.41195 5.43673C7.63385 5.43673 8.37257 6.22914 8.54994 6.44321C9.15886 6.23458 9.82757 6.11633 10.5303 6.11633C11.2343 6.11633 11.9058 6.23458 12.516 6.44457C12.6914 6.23186 13.4308 5.43673 14.6554 5.43673C15.1529 5.93352 14.9143 7.24173 14.7247 7.87919C15.2929 8.5214 15.6272 9.28322 15.6272 10.0716C15.6272 11.9044 14.3333 13.2548 11.6217 13.5354C12.3679 13.9248 12.9122 15.019 12.9122 15.8433V17.7013C12.9122 17.772 12.8966 17.823 12.8885 17.8835C16.0662 16.7696 18.349 13.7522 18.349 10.1939C18.349 5.69022 14.6975 2.03878 10.1939 2.03878Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3_206)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29.2225,
    height: 27.1837,
    fill: "#05386B"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithubIcon);
export default __webpack_public_path__ + "static/media/github-icon.10f27cbfd14ae23d279b7a1018d4f4d6.svg";
export { ForwardRef as ReactComponent };